import React from 'react';
import { IconMenuKebab } from '@prisjakt/ui/icon';
import * as S from './styles';

interface IExpandButton {
  expanded?: boolean;
  onClick?: () => void;
  title?: string;
  featured: boolean;
}

export const ExpandButton: React.FC<IExpandButton> = ({
  expanded = false,
  onClick,
  title,
  featured,
}) => {
  const color = featured ? 'maybeBlue700' : 'base500';

  return (
    <S.ExpandButton
      type="button"
      aria-label={title}
      onClick={onClick}
      data-test="ExpandButton"
      $expanded={expanded}
    >
      <IconMenuKebab color={color} size={24} />
    </S.ExpandButton>
  );
};
